module.exports = __webpack_public_path__ + "img/splash.5d56adfa.jpeg";